import { isAndroid } from '../utils/platform';
import { getVersionGateState } from './versionGate';

export async function configureBackButton(): Promise<void> {
  if (!isAndroid()) return;

  const { App: CapApp } = await import('@capacitor/app');

  CapApp.addListener('backButton', ({ canGoBack }) => {
    // The force-upgrade gate is non-dismissable — swallow back entirely
    // (no history navigation, no minimize) while it is up.
    if (getVersionGateState().gated) return;

    // Close any open offcanvas first
    const offcanvas = document.querySelector('.offcanvas.show');
    if (offcanvas) {
      const closeBtn = offcanvas.querySelector(
        '.offcanvas-header .btn-close, [data-bs-dismiss="offcanvas"]'
      ) as HTMLElement | null;
      if (closeBtn) {
        closeBtn.click();
        return;
      }
    }

    // Close any open modal
    const modal = document.querySelector('.modal.show');
    if (modal) {
      const closeBtn = modal.querySelector(
        '.modal-header .btn-close, [data-bs-dismiss="modal"]'
      ) as HTMLElement | null;
      if (closeBtn) {
        closeBtn.click();
        return;
      }
    }

    if (canGoBack) {
      window.history.back();
    } else {
      CapApp.minimizeApp();
    }
  });
}
